// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"2d1aa241","211":"3b5d320d","296":"ec360a54","453":"10721639","545":"e8495af3","879":"499cbdb5"}[chunkId] + ".chunk.js";
};